import React from 'react';
import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';

export const LoadingState = ({ label = 'Loading…' }: { label?: string }) => (
  <Box
    sx={{
      minHeight: 240,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Stack alignItems="center" spacing={2}>
      <CircularProgress />
      <Typography color="text.secondary">{label}</Typography>
    </Stack>
  </Box>
);

export const EmptyState = ({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: React.ReactNode;
}) => (
  <Stack
    spacing={2}
    alignItems="flex-start"
    sx={{
      p: 4,
      borderRadius: 4,
      border: (theme) => `1px dashed ${theme.palette.divider}`,
      backgroundColor: 'background.paper',
    }}
  >
    <Typography variant="h6">{title}</Typography>
    <Typography color="text.secondary">{description}</Typography>
    {action}
  </Stack>
);

export const ErrorState = ({
  message,
  retryLabel = 'Try again',
  onRetry,
}: {
  message: string;
  retryLabel?: string;
  onRetry?: () => void;
}) => (
  <Stack spacing={2}>
    <Alert severity="error">{message}</Alert>
    {onRetry ? (
      <Box>
        <Button variant="outlined" onClick={onRetry}>
          {retryLabel}
        </Button>
      </Box>
    ) : null}
  </Stack>
);
